import React, { useEffect, useState } from 'react'
import { GetPriorityListInitial, SetHighlightsVideioList } from '../../Services/allApi';
import { toast } from 'react-toastify';

function EditHighlights({ setisUpdateOpen2 }) {
    const [errorMsg, setErrorMsg] = useState()
    const [videoIds, setVideoIds] = useState({
        1: '',
        2: '',
        3: '',
        4: '',
        5: '',
        6: '',
        7: '',
        8: '',
        9: '',
        10: '',
    });
    const [videoPriorityList, setvideoPriorityList] = useState([{
        video: '',
        priority: ''
    }])
    // updates video ids when chnages an id
    const handleChange = (event) => {
        const { name, value } = event.target;
        setVideoIds({ ...videoIds, [name]: value });
    };
    // API to submit highlight videos ids
    const handleSubmit = async (event) => {
        event.preventDefault();
        const updatedPriorityList = Object.entries(videoIds).map(([key, value]) => ({
            video_id: value,
            priority: key
        }));
        setvideoPriorityList(updatedPriorityList);
        console.log(updatedPriorityList);
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        try {
            const result = await SetHighlightsVideioList(updatedPriorityList, reqHeader);
            const error = result?.response?.data?.error;
            console.log(result);

            if (result.status === 200) {
                setisUpdateOpen2(false);
                toast.success("Highlight list updated successfully");
            } else {
                const errorMessage = error ?? 'There was an error updating highlight videos';
                toast.error(result?.response?.data?.message ?? 'There was an error updating highlight videos');
                // setErrorMsg(errorMessage);
            }
        } catch (error) {
            console.error("API call failed:", error);
            const errorMessage = error?.response?.data?.error ?? 'An unexpected error occurred';
            // setErrorMsg(errorMessage);
            toast.error(errorMessage);
        }
    };
    const getListOfPriorityId = async () => {
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        const res = await GetPriorityListInitial(reqHeader)
        console.log(res);
        // setVideoIds()
        console.log(res?.data);
        const ApiFormat = res?.data?.data;
        const newList = {};
        ApiFormat?.forEach(item => {
            if (item?.priority && item?.video_id) {
                newList[item.priority] = item.video_id;
            }
        });
        setVideoIds(newList)
        console.log(newList); // Output the transformed object
    }
    useEffect(() => {
        getListOfPriorityId()
    }, [])
    return (
        <div className="w-full  p-6 rounded-lg shadow-xl  border-blue-500">
            <h2 className="text-2xl font-bold mb-4">Enter Video Mapping IDs</h2>
            <form onSubmit={handleSubmit} className="flex flex-wrap justify-center gap-x-10 gap-y-2 ">
                {[...Array(10).keys()].map((index) => (
                    <div key={index} className="w-full sm:w-1/2 md:w-2/12">
                        <label htmlFor={`videoId${index + 1}`} className="block text-sm font-medium text-gray-700 mb-1 ">
                            Video {index + 1} Mapping Id:
                        </label>
                        <input
                            type="text"
                            id={`Mapping Id${index + 1}`}
                            name={`${index + 1}`}
                            value={videoIds[index + 1]}
                            onChange={handleChange}
                            className="border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border"
                            placeholder="Enter video ID"
                        />
                    </div>
                ))}
                <br />
                <div className='flex justify-center items-center w-full'>
                    <button
                        type="submit"
                        className="mt-2 mb-2 bg-blue-500 text-white py-2 w-1/12 rounded-md shadow-sm hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                    >
                        Submit
                    </button>
                </div>
            </form>
        </div>)
}

export default EditHighlights